module.exports = __webpack_public_path__ + "images/job/detail/detail_icon06-acdb1202a3eb29c0edce185f7b970880.png";